import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

import { BREAKPOINTS_VALUES } from '../../../../theme';
import IKImage from '../../../IKImage/IKImage';
import useStyles from './styles';

interface BottomItemProps {
  title?: string | null;
  imageUrl?: string | null;
  image?: React.ReactNode | null;
}

const BottomItem: FC<BottomItemProps> = ({ title, imageUrl, image }) => {
  const classes = useStyles();

  return (
    <div className={classes.bottomItem}>
      <div className={classes.bottomItemImageWrapper}>
        {image || (
          <IKImage
            className={classes.bottomItemImg}
            path={imageUrl}
            draggable={false}
            alt={title}
            srcset={[{ width: 65 }, { width: 40 }]}
            sizes={`(max-width:${BREAKPOINTS_VALUES['md']}px) 40px, 65px`}
          />
        )}
      </div>
      <Typography className={classes.bottomItemText}>{title}</Typography>
    </div>
  );
};

export default BottomItem;
